module.exports = __webpack_public_path__ + "bf31ff6c6c823fd96da0d95bb35ccf72.eot";


//////////////////
// WEBPACK FOOTER
// ./src/font/ppa-icon.eot
// module id = 847
// module chunks = 2